(function () {
    const dropdown = document.querySelector('.dropdown__clubs.hover');

    if (dropdown) {
        const items = dropdown.querySelector('.dropdown__items');
        const wrapper = dropdown.querySelector('.dropdown__clubs-wrapper');

        if (items && wrapper) {
            items.style.display = 'block';
            items.style.opacity = 0;
            items.style.visibility = 'hidden';

            items.style.width = wrapper.scrollWidth + 60 + 'px';

            items.style.display = '';
            items.style.opacity = '';
            items.style.visibility = '';
        }
    }
})();
